import React from 'react';
import { HotelDuotoneIcon } from '../../Common/SVGBank';

const BookingItem = ({ booking }) => {
    const hotel = booking.hotel_data;
    const address = hotel?.address || {};
    const city = address?.city_name || hotel?.city?.name || '';
    const country = address?.country_code || hotel?.city?.MuvMetaCity?.country || '';
    const title = hotel?.property_name || 'Hotel';
    const image = hotel?.photo_data?.[0] || 'https://via.placeholder.com/400x220';
    const startDate = new Date(booking.created_at); // NOTE: use real check-in/out if available
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 3); // fake 3-day span for demo
    const dateLabel = `${startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${endDate.toLocaleDateString('en-US', { day: 'numeric', year: 'numeric' })}`;


    const goToBooking = () => {
        const affiliateId = booking?.affiliate_reference_id;
        const email = booking?.email;
        if (affiliateId && email) {
            const url = `/payment/details?email=${email}&affiliateId=${affiliateId}`;
            window.open(url);
        }
    };

    if (!hotel) {
        return null
    }
    return (
        <div
            style={{
                width: '100%',
                maxWidth: '400px',
                height: '180px',
                position: 'relative',
                marginBottom: 20,
                overflow: 'hidden',
                cursor: 'pointer',
                color: '#fff',
            }}
            onClick={goToBooking}
        >
            {/* Background image with dim overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url(${image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    filter: 'brightness(60%)',
                    zIndex: 1,
                }}
            />

            {/* Content overlay */}
            <div style={{
                position: 'relative',
                zIndex: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
            }}>
                <div style={{
                    padding: '40px 16px',
                    fontFamily: 'Futura Lt BT'
                }}>
                    <div style={{ fontSize: 13 }}>{city}</div>
                    <div style={{ fontSize: 20, fontFamily: 'Futura Md BT' }}>{title}</div>
                    {/* <div style={{ fontSize: 14 }}>{dateLabel}</div> */}
                </div>
                <div style={{ position: 'absolute', top: 12, right: 20 }}>
                    <HotelDuotoneIcon width={19} height={15} style={{ marginRight: "0px", marginTop: "0px" }} fill={'white'} />
                </div>
            </div>
        </div>
    );

};

export default BookingItem;
